export const getUniqueArray = (arr: number[]) => {
  const uniqueArray = arr.filter(
    (value, index, self) => self.indexOf(value) === index,
  );

  return uniqueArray;
};
